<template>
    <e-autocomplete
        :data="data"
        field="title"
        :label="computedLabel"
        :help="help"
        placeholder="Type an activity..."
        :loading="isFetching"
        clearable
        @esc="$emit('update:modelValue', null)"
        @clear="$emit('update:modelValue', null)"
        @typing="getAsyncData"
        @select="activity => $emit('update:modelValue', activity)"
    >
        <template #default="props">
            <span :title="props.option.title">{{ props.option.title }}</span>
        </template>
    </e-autocomplete>
</template>

<script>
import debounce from 'lodash/debounce.js';
import { useI18n } from 'vue-i18n';

import axios from '@/plugins/axios.js';

export default {
    name: 'ActivitySearch',

    emits: ['update:modelValue'],

    props: {
        modelValue: {
            type: Object,
            required: false,
            default: () => ({}),
        },

        label: {
            type: String,
            default: null,
            validator: prop => typeof prop === 'string' || prop === null,
        },

        help: {
            type: String,
            required: false,
            default: '',
        },

        courseId: {
            type: [Number, null],
            required: false,
            default: null,
        },
    },

    data() {
        return {
            data: [],
            selected: null,
            isFetching: false,
        };
    },

    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },

    computed: {
        computedLabel() {
            return typeof this.label === 'string' ? this.label : this.translate('select_an_activity');
        },
    },

    methods: {
        getAsyncData: debounce(function getAsyncData(name) {
            if (!name.length) {
                this.data = [];
                return;
            }
            this.isFetching = true;

            let requestUrl;
            if (this.courseId != null) {
                requestUrl = `/api/activities?search=${name}&filter[course_id]=${this.courseId}&include=section.sectionSettings`;
            } else {
                requestUrl = `/api/activities?search=${name}&include=section.sectionSettings`;
            }

            axios
                .get(requestUrl)
                .then(({ data }) => {
                    this.data = [];
                    data.data.forEach(item => this.data.push(item));
                })
                .catch(error => {
                    this.data = [];
                    throw error;
                })
                .finally(() => {
                    this.isFetching = false;
                });
        }, 500),
    },
};
</script>
